"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
var _loadableComponents = _interopRequireDefault(require("loadable-components"));
var _RoomCard = require("./RoomCard.propTypes");
var _Utils = require("./Utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PriceInfoMobile = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"PriceInfoMobile" */"./PriceInfo"));
  });
});
var OptionsAndBenefitsInfoMobile = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"OptionsAndBenefitsInfoMobile" */"./OptionsAndBenefitsInfo"));
  });
});
var BigPointToBeEarned = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"BigPointToBeEarned" */"@airasia/phoenix-components/components/BigPointToBeEarned"));
  });
});
var Button = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require( /* webpackChunkName:"Button" */"@airasia/phoenix-components/components/Button"));
  });
});
var RateContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateInfoMobile__RateContentWrapper",
  componentId: "sc-ilyotl-0"
})(["background-color:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor.default;
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 'display: flex; justify-content: space-between; flex-direction: column;' : '';
});
var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateInfoMobile__ContentWrapper",
  componentId: "sc-ilyotl-1"
})(["", ""], function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? 'display: flex; flex-direction: row;' : '';
});
var CTAWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateInfoMobile__CTAWrapper",
  componentId: "sc-ilyotl-2"
})(["padding:", ";display:flex;justify-content:flex-end;"], function (_ref4) {
  var theme = _ref4.theme;
  return "0 0 ".concat(theme.space.small, " 0");
});
var BigPointsWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateInfoMobile__BigPointsWrapper",
  componentId: "sc-ilyotl-3"
})(["padding:", ";display:flex;justify-content:flex-end;"], function (_ref5) {
  var theme = _ref5.theme;
  return "0 0 ".concat(theme.space.small, " 0");
});
var RateOrderWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateInfoMobile__RateOrderWrapper",
  componentId: "sc-ilyotl-4"
})(["display:flex;align-items:center;padding:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.space.XSmall, " 0 ").concat(theme.space.tiny, " 0");
});
var RateOrder = _styledComponents.default.div.withConfig({
  displayName: "RateInfoMobile__RateOrder",
  componentId: "sc-ilyotl-5"
})(["font-size:", ";font-weight:", ";line-height:", ";color:", ";margin-right:", ";"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontSize.normal;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontWeight.medium;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight.XLarge;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.neutral;
}, function (_ref11) {
  var theme = _ref11.theme,
    isHasTag = _ref11.isHasTag,
    isMobile = _ref11.isMobile;
  return (
    // eslint-disable-next-line no-nested-ternary
    isHasTag ? isMobile ? theme.space.tiny : theme.space.XSmall : 0
  );
});
var TagWrapper = _styledComponents.default.div.withConfig({
  displayName: "RateInfoMobile__TagWrapper",
  componentId: "sc-ilyotl-6"
})(["background-color:", ";color:", ";padding:", ";font-size:", ";line-height:", ";border-radius:", ";font-weight:", ";margin-right:", ";"], function (_ref12) {
  var theme = _ref12.theme,
    backgroundColor = _ref12.backgroundColor;
  return !backgroundColor ? theme.backgroundColor.blueLight : theme.backgroundColor[backgroundColor];
}, function (_ref13) {
  var theme = _ref13.theme,
    color = _ref13.color;
  return !color ? theme.colors.secondary : theme.colors[color];
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.space.micro;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontSize.XSmall;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.lineHeight.small;
}, function (_ref17) {
  var theme = _ref17.theme,
    borderRadius = _ref17.borderRadius;
  return !borderRadius ? theme.borderRadius.normal : theme.borderRadius[borderRadius];
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontWeight.medium;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.space.micro;
});
var RateInfoMobile = function RateInfoMobile(_ref20) {
  var _bedGroups$0$token, _bedGroups$;
  var isMobile = _ref20.isMobile,
    theme = _ref20.theme,
    rate = _ref20.rate,
    isShowRateName = _ref20.isShowRateName,
    index = _ref20.index,
    _ref20$translations = _ref20.translations,
    translations = _ref20$translations === void 0 ? {} : _ref20$translations,
    onSelectRoomHandler = _ref20.onSelectRoomHandler,
    occupancy = _ref20.occupancy,
    onShowRateDetailHandler = _ref20.onShowRateDetailHandler,
    isSingleOption = _ref20.isSingleOption,
    promoTitle = _ref20.promoTitle,
    discountType = _ref20.discountType,
    roomAmenity = _ref20.roomAmenity,
    roomAmenityName = _ref20.roomAmenityName,
    includedInPriceHeader = _ref20.includedInPriceHeader,
    applyBigpoints = _ref20.applyBigpoints,
    bigMembership = _ref20.bigMembership,
    roomOccupancy = _ref20.roomOccupancy,
    isSnap = _ref20.isSnap,
    locale = _ref20.locale,
    soldOutBedGroupTokens = _ref20.soldOutBedGroupTokens,
    lowInventoryFOMO = _ref20.lowInventoryFOMO,
    isBogoPromoEnabled = _ref20.isBogoPromoEnabled,
    bogoMessage = _ref20.bogoMessage,
    bogoTag = _ref20.bogoTag,
    payNowMessage = _ref20.payNowMessage,
    isPayNowEnabled = _ref20.isPayNowEnabled,
    move = _ref20.move,
    isBlockedRateIsEnabled = _ref20.isBlockedRateIsEnabled;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var id = rate.id,
    rateName = rate.rateName,
    discountText = rate.discountText,
    strikeThrough = rate.strikeThrough,
    totalPrice = rate.totalPrice,
    CTAButtonText = rate.CTAButtonText,
    cancellationPenaltyType = rate.cancellationPenaltyType,
    freeCancellationText = rate.freeCancellationText,
    payLaterText = rate.payLaterText,
    payAtHotelText = rate.payAtHotelText,
    instantConfirmationText = rate.instantConfirmationText,
    nonRefundableText = rate.nonRefundableText,
    partiallyRefundableText = rate.partiallyRefundableText,
    _rate$amenities = rate.amenities,
    amenities = _rate$amenities === void 0 ? [] : _rate$amenities,
    refundable = rate.refundable,
    price = rate.price,
    recommendedText = rate.recommendedText,
    flierDiscountText = rate.flierDiscountText,
    baseRate = rate.baseRate,
    baseRateAfterBigPointsDeduction = rate.baseRateAfterBigPointsDeduction,
    totalPayable = rate.totalPayable,
    _rate$bigPoint = rate.bigPoint,
    bigPoint = _rate$bigPoint === void 0 ? {} : _rate$bigPoint,
    payLater = rate.payLater,
    isFreeCancellation = rate.isFreeCancellation,
    isNonRefundable = rate.isNonRefundable,
    payAtHotel = rate.payAtHotel,
    perGuestText = rate.perGuestText,
    snapPriceText = rate.snapPriceText,
    bedGroupsOptions = rate.bedGroupsOptions,
    perPersonBaseRate = rate.perPersonBaseRate,
    bedGroups = rate.bedGroups,
    isPayLater = rate.isPayLater,
    isPayAtHotel = rate.isPayAtHotel,
    isBlockedRate = rate.isBlockedRate;
  var token = (_bedGroups$0$token = bedGroups === null || bedGroups === void 0 || (_bedGroups$ = bedGroups[0]) === null || _bedGroups$ === void 0 ? void 0 : _bedGroups$.token) !== null && _bedGroups$0$token !== void 0 ? _bedGroups$0$token : null;
  var isSoldOut = soldOutBedGroupTokens ? soldOutBedGroupTokens.includes(token) : false;
  if (isBlockedRate && isBlockedRateIsEnabled) {
    isSoldOut = true;
  }
  var _ref21 = bigPoint || {},
    template = _ref21.template,
    pointTemplate = _ref21.pointTemplate,
    pointValue = _ref21.pointValue,
    multiplierTemplate = _ref21.multiplierTemplate,
    multiplierValue = _ref21.multiplierValue,
    customProperties = _ref21.customProperties;
  var freeCancellation = translations.freeCancellation,
    nonRefundable = translations.nonRefundable,
    partiallyRefundable = translations.partiallyRefundable,
    option = translations.option,
    perNight = translations.perNight,
    perRoomPerNight = translations.perRoomPerNight,
    adultsText = translations.adults,
    childrenText = translations.children,
    moreDetails = translations.moreDetails,
    perGuest = translations.perGuest,
    messageFOMO = translations.messageFOMO,
    soldOutCTA = translations.soldOutCTA;
  var newTextButtonCTA = isSoldOut ? soldOutCTA : CTAButtonText;
  var onSelectRateHandler = function onSelectRateHandler() {
    onSelectRoomHandler(rate);
  };
  var borderColor;
  var textColor;
  var hoverColor;
  var hoverBackgroundColor;
  if (isSoldOut) {
    borderColor = '#f8f8f8';
    textColor = '#c5c9d0';
    hoverColor = 'none';
    hoverBackgroundColor = 'none';
  } else {
    borderColor = move ? 'secondary' : 'primary';
    textColor = move ? 'secondary' : 'primary';
    hoverColor = move ? 'secondary' : 'default';
    hoverBackgroundColor = move ? 'secondaryLight' : 'primary';
  }
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(RateContentWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(RateOrderWrapper, null, !isSingleOption ? /*#__PURE__*/_react.default.createElement(RateOrder, {
      isHasTag: ((0, _Utils.isNotEmpty)(recommendedText) || (0, _Utils.isNotEmpty)(flierDiscountText)) && !isSingleOption,
      isMobile: isMobile
    }, isShowRateName && rateName ? rateName : "".concat(option, " ").concat(index + 1)) : /*#__PURE__*/_react.default.createElement(RateOrder, {
      isMobile: isMobile
    }, " ", isShowRateName && rateName ? rateName : '', " "), !isSingleOption && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _Utils.isNotEmpty)(recommendedText) && /*#__PURE__*/_react.default.createElement(TagWrapper, {
      color: move && 'oldSecondary',
      borderRadius: move && 'XXnormal'
    }, recommendedText), (0, _Utils.isNotEmpty)(flierDiscountText) && /*#__PURE__*/_react.default.createElement(TagWrapper, {
      color: move && 'oldSecondary',
      borderRadius: move && 'XXnormal'
    }, flierDiscountText))), /*#__PURE__*/_react.default.createElement(ContentWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(OptionsAndBenefitsInfoMobile, {
      rateName: rateName,
      isShowRateName: isShowRateName,
      index: index,
      option: option,
      theme: theme,
      cancellationPenaltyType: cancellationPenaltyType,
      freeCancellationText: freeCancellationText,
      freeCancellation: freeCancellation,
      payLaterText: payLaterText,
      payLater: payLater,
      refundable: refundable,
      isFreeCancellation: isFreeCancellation,
      isNonRefundable: isNonRefundable,
      payAtHotel: payAtHotel,
      payAtHotelText: payAtHotelText,
      nonRefundableText: nonRefundableText,
      nonRefundable: nonRefundable,
      partiallyRefundableText: partiallyRefundableText,
      partiallyRefundable: partiallyRefundable,
      instantConfirmationText: instantConfirmationText,
      isMobile: isMobile,
      amenities: amenities,
      occupancy: occupancy,
      adultsText: adultsText,
      childrenText: childrenText,
      moreDetails: moreDetails,
      onShowRateDetailHandler: onShowRateDetailHandler,
      recommendedText: recommendedText,
      flierDiscountText: flierDiscountText,
      promoTitle: promoTitle,
      discountType: discountType,
      id: id,
      roomOccupancy: roomOccupancy,
      isSnap: isSnap,
      bedGroupsOptions: bedGroupsOptions,
      isSingleOption: isSingleOption,
      discountText: discountText,
      totalPrice: totalPrice,
      strikeThrough: strikeThrough,
      totalPayable: totalPayable,
      onSelectRateHandler: onSelectRateHandler,
      bigMembership: bigMembership,
      applyBigpoints: applyBigpoints,
      bigPoint: bigPoint,
      roomAmenity: roomAmenity,
      baseRate: baseRate,
      CTAButtonText: CTAButtonText,
      includedInPriceHeader: includedInPriceHeader,
      baseRateAfterBigPointsDeduction: baseRateAfterBigPointsDeduction,
      locale: locale,
      perGuestText: perGuestText,
      snapPriceText: snapPriceText,
      roomAmenityName: roomAmenityName,
      messageFOMO: messageFOMO,
      isSoldOut: isSoldOut,
      lowInventoryFOMO: lowInventoryFOMO,
      isBogoPromoEnabled: isBogoPromoEnabled,
      bogoMessage: bogoMessage,
      payNowMessage: payNowMessage,
      isPayNowEnabled: isPayNowEnabled && Boolean(!isPayLater && !isPayAtHotel)
    }), !isMobile && /*#__PURE__*/_react.default.createElement(PriceInfoMobile, {
      discountText: discountText,
      strikeThrough: strikeThrough,
      price: bigMembership && applyBigpoints ? baseRateAfterBigPointsDeduction : price,
      totalPrice: bigMembership && applyBigpoints ? totalPayable : totalPrice,
      theme: theme,
      CTAButtonText: newTextButtonCTA,
      baseRate: baseRate,
      onSelectRateHandler: onSelectRateHandler,
      isMobile: isMobile,
      perRoomPerNight: perRoomPerNight,
      perNight: perNight,
      perGuestText: perGuestText,
      snapPriceText: snapPriceText,
      perPersonBaseRate: perPersonBaseRate,
      isSnap: isSnap,
      locale: locale,
      perGuest: perGuest,
      isSoldOut: isSoldOut,
      isBogoPromoEnabled: isBogoPromoEnabled,
      bogoTag: bogoTag
    })), isMobile && /*#__PURE__*/_react.default.createElement(PriceInfoMobile, {
      discountText: discountText,
      strikeThrough: strikeThrough,
      price: bigMembership && applyBigpoints ? baseRateAfterBigPointsDeduction : price,
      totalPrice: bigMembership && applyBigpoints ? totalPayable : totalPrice,
      theme: theme,
      perNight: perNight,
      CTAButtonText: newTextButtonCTA,
      baseRate: baseRate,
      onSelectRateHandler: onSelectRateHandler,
      isMobile: isMobile,
      perRoomPerNight: perRoomPerNight,
      perGuestText: perGuestText,
      snapPriceText: snapPriceText,
      perPersonBaseRate: perPersonBaseRate,
      isSnap: isSnap,
      locale: locale,
      perGuest: perGuest,
      isSoldOut: isSoldOut,
      isBogoPromoEnabled: isBogoPromoEnabled,
      bogoTag: bogoTag
    }), isMobile && /*#__PURE__*/_react.default.createElement(CTAWrapper, null, /*#__PURE__*/_react.default.createElement(Button, {
      border: borderColor,
      color: textColor,
      hoverColor: hoverColor,
      hoverBackgroundColor: hoverBackgroundColor,
      boxShadow: !isSoldOut,
      width: isMobile ? '50%' : '100%',
      paddingLeft: "0px",
      paddingRight: "0px",
      handleClick: isSoldOut ? function () {} : onSelectRateHandler,
      fontWeight: "medium",
      disabled: isSoldOut
    }, newTextButtonCTA)), isMobile && template && /*#__PURE__*/_react.default.createElement(BigPointsWrapper, null, /*#__PURE__*/_react.default.createElement(BigPointToBeEarned, {
      template: template,
      pointTemplate: pointTemplate,
      pointValue: pointValue,
      multiplierTemplate: multiplierTemplate,
      multiplierValue: multiplierValue,
      customProperties: customProperties
    }))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
RateInfoMobile.propTypes = _RoomCard.RateInfoPropTypes;
RateInfoMobile.defaultProps = _RoomCard.RateInfoDefaultValues;
var _default = RateInfoMobile;
exports.default = _default;